import React, { useState, useEffect, Fragment, useContext } from 'react';
import FormSectionNew from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import DivLayout from 'components/sales/divLayout/divLayout';
import Layout from 'components/sales/layout/layout';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import ModalPop from 'components/sales/modal/modal';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import { isReportComplete } from 'services/utils/reportUrl/reportUrl';
import './consolidateReport.css'
export const ConsolidateReport = ({
  documentUploadUrl,
  match,
  postReportDetails,
  reportFlag,
  reportUrl = null,
  reportStatus = null,
  mrf = null,
  generateReport,
  refreshPage,
  pocListBySiteId,
  postSendReportMail,
  isReportPending = false,
  reportPendingMessage = '',
}) => {
  const data = {
    site_id: match.params.id,
    client_photo: '',
    client_signature: '',
    site_layouts: [],
    site_images: [],
  };
  const { baseUrl } = useContext(BaseUrl);
  const [formData, setformData] = useState(data);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [formFlag, setFormFlag] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [poclist, setPocList] = useState([]);
  const [showOtherEmail, setShowOtherEmail] = useState(false);
  const [mailList, setMailList] = useState([]);
  const [otherEmail, setOtherEmail] = useState();
  const [modal, setModal] = useState(false);

  useEffect(() => {
    const list =
      poclist && poclist.length > 0 && poclist.map((element) => element['id']);
    // const list = poclist  && poclist.id;
    setMailList(list);
  }, [poclist]);

  const sendMailPoc = async () => {
    const findIndex =
      mailList &&
      mailList.length > 0 &&
      mailList.findIndex((el) => el === 'Others');
    if (findIndex !== -1 && findIndex != false) {
      mailList.splice(findIndex, 1);
      mailList.push(otherEmail);
      setMailList([...mailList]);
    }
    console.log(mailList);
    setTimeout(async () => {
      const data = {
        stage_id: match.params.stageId,
        site_id: match.params.id,
        pocs: mailList,
      };
      if (data.pocs.length > 0) {
        setIsLoading(true);
        openHideModal();
        const res = await postSendReportMail(data);
        if (res === true) {
          setIsLoading(false);
          setModal(true);
        }
      }
    }, 1000);
  };

  const openHideModal = () => setOpenModal(false);
  const emailModalHide = () => setModal(false);

  const handleModalHide = () => {
    setIsModal(false);
    refreshPage(true);
  };

  const sendMail = (val) => {
    if (val) {
      setOpenModal(true);
    }
  };
  useEffect(() => {
    (() => {
      if (
        poclist &&
        poclist.length > 0 &&
        poclist.some((obj) => obj.id === 'Others')
      ) {
        setShowOtherEmail(true);
      } else {
        setShowOtherEmail(false);
      }
    })();
  }, [poclist]);

  const onSubmit = async () => {
    if (
      formData.site_layouts.length > 0 &&
      formData.site_images.length > 0 &&
      formData.client_photo !== '' &&
      formData.client_signature !== ''
    ) {
      setIsLoading(true);
      const res = await postReportDetails(formData);
      setIsLoading(false);

      if (res) {
        setFormFlag(false);
        setIsModal(true);
      }
    } else setFormFlag(true);
  };

  return (

    <FormSectionNew title={localization.consolidateReport} isLoading={isLoading}>
      {reportFlag === true && (
        <Fragment>
          {isReportComplete({ report_url: reportUrl, report_status: reportStatus }) &&
          mrf &&
          Object.keys(mrf).length > 0 ? (
            <Fragment>
              <div className="form-group">
                <DocumentView attachment={reportUrl} />
              </div>
              <div className="form-group">
                <Checkbox
                  label={localization.notify}
                  onChange={(val) => sendMail(val)}
                  type="checkbox"
                />
              </div>
            </Fragment>
          ) : isReportPending ? (
            <Fragment>
              <div className="form-group form-section">
                <p className="text-muted mb-0">
                  {reportPendingMessage || localization.reportGenerating}
                </p>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div className="form-group form-section">
                <Button
                  className="btn btn-primary"
                  onClick={() => generateReport(true)}
                >
                  {localization.generateReport}
                </Button>
              </div>
            </Fragment>
          )}
        </Fragment>
      )}

      {reportFlag === false && (
        <div action="" className="details-listing ">
          <div className="upload_client">
          <div className="row">
          <div className="col-md-3">
            <div className="form-group">
            <FileUpload
              id="UploadSiteLayout"
              multiple
              documentUploadUrl={documentUploadUrl}
              onChange={(val) =>
                setformData({ ...formData, site_layouts: val })
              }
              // onLoading={(val)=>{console.log(val);}}
            >
              <span className="btn btn-primary btn-btn">
                {localization.UploadSiteLayout}
              </span>
            </FileUpload>
            </div>
            </div>
          <div className="col-md-3">
          <div className="form-group">
            <FileUpload
              id="clientSignature"
              documentUploadUrl={documentUploadUrl}
              onChange={(val) =>
                setformData({ ...formData, client_signature: val })
              }
            >
              <span className="btn btn-primary align-btn">
                {localization.clientSignature}
              </span>
            </FileUpload>
          </div>
      </div>
    
          <div className="col-md-3">
            <div className="form-group">
              
              <FileUpload
                id="capturePOC"
                documentUploadUrl={documentUploadUrl}
                onChange={(val) =>
                  setformData({ ...formData, client_photo: val })
                }
              >
                <span className="btn btn-primary Capture-btn">
                  {localization.capturePOC}
                </span>
              </FileUpload>
            

            </div>
            </div>
            
            <div className="col-md-3 ">
            <div className="Submit-Details">
            <div className="form-group ">
              <FileUpload
                id="siteImages"
                documentUploadUrl={documentUploadUrl}
                multiple
                onChange={(val) => {
                  setformData({ ...formData, site_images: val });
                }}
              >
                <span className="btn btn-primary">
                  {localization.siteImages}
                </span>
              </FileUpload>
            </div>
          </div>
          </div>
          <label className={`error ${formFlag ? 'd-block' : ''}`}>
                {localization.uploadError}
              </label>
          </div>
          
            <div className="form-group Submit_align">
              
           
              <Button className="transparent11" onClick={onSubmit}>
                {localization.submitDtl}
                <img src={Images?.ArrowRight} alt="" />
              </Button>
            </div>
          </div>
         </div>
      
       
      )}
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.saveSuccessfully}</h5>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.notify}
        show={openModal}
        handleModalHide={openHideModal}
        keyboard
        backdrop
      >
        <div className="text-center">
          <DropDownInput
            multipule
            label={localization.toName}
            data={pocListBySiteId}
            required
            isStarRequired={true}
            errorMsg={localization.isRequired}
            getIdValue={(val) => {
              setPocList(val);
            }}
          />
          {showOtherEmail && (
            <ConstantInput
              label={localization.emailAddress}
              regex={Regex.email.test(otherEmail)}
              errorMsg={localization.emailError}
              handleChange={(val) => {
                setOtherEmail(val);
              }}
              type="text"
            />
          )}
          <Button
            className="btn btn-primary mb-4"
            onClick={() => {
              sendMailPoc();
            }}
          >
            {localization.submit} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
        
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={modal}
        handleModalHide={emailModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.mailSuccessfully}</h5>
        </div>
       
      </ModalPop>
    </FormSectionNew>
    
  );
};
